import * as fromRoot from '../../../state/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReasonActions, ReasonActitonTypes } from './reason.actions';
import { User } from '../../../_models/user';
import { Reason } from '../../../_models/reason';
import { ReasonType } from '../../../_models/reason_type';

export interface State extends fromRoot.State {
	reasons: ReasonState;
}

export interface ReasonState {
  currentReasonId: bigint | null;
  currentReason: Reason;
	reasonList: Reason[];
	reasonTypeList: ReasonType[];
	userList: User[];

	filterFields: any;

	error: string;
}

const initialItem: Reason = {
  id: null,
  name: '',
  type_id: null,
  description: null,
	text: null,
	color: null,
  order: 0,
  active: 0,
};

const initialState: ReasonState = {
  currentReasonId: null,
  currentReason: initialItem,
	reasonList: [],
  reasonTypeList: [],
	userList: [],
	filterFields: [],
	error: ''
};

const getReasonFeatureState = createFeatureSelector<ReasonState>('reasons');

export const getCurrentReasonId = createSelector(
	getReasonFeatureState,
	state => state.currentReasonId
);

export const getCurrentReason = createSelector(
    getReasonFeatureState,
    getCurrentReasonId,
    (state, currentReasonId) => {
        if (currentReasonId == null) {
            return initialItem;
        } else {
            return currentReasonId ? state.reasonList.find(p => p.id === currentReasonId) : null;
        }
    }
);

export const getReasonList = createSelector(
	getReasonFeatureState,
	state => state.reasonList
);

export const getReasonTypesList = createSelector(
	getReasonFeatureState,
	state => state.reasonTypeList
);

export const getUserList = createSelector(
	getReasonFeatureState,
	state => state.userList
);

export const getFilterFields = createSelector(
	getReasonFeatureState,
	state => state.filterFields
);

export const getError = createSelector(
	getReasonFeatureState,
	state => state.error
);

// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: ReasonActions): ReasonState {

	// console.log('--> Reason Reduce --> Estado actual: ' + JSON.stringify(state));
	// console.log('--> Action Reason type: ');
	// console.log(action.type);

	switch (action.type) {

		case ReasonActitonTypes.SetCurrentReason:

			console.log('--> Entando en acción SetCurrentReason.');

			if (action.payload !== null) {

				return {
					...state,
					currentReasonId: action.payload.id,
					currentReason: action.payload
				};
			} else {
				return {
					...state,
					currentReasonId: null,
					currentReason: initialItem
				};
			}

		case ReasonActitonTypes.SetCurrentReasonId:

			console.log('--> Entando en acción SetCurrentReason.');

			return {
                ...state,
				currentReasonId: action.payload
			};

		case ReasonActitonTypes.SetFilterFields:

			console.log('--> Entando en acción SetFilterFields.');

			return {
                ...state,
                filterFields: action.payload
			};

        case ReasonActitonTypes.GetCurrentReason:

			console.log('--> Entando en acción GetCurrentReason.');

			return state;

		case ReasonActitonTypes.ClearReason:

			console.log('--> Entando en acción ClearReason.');

			return {
					...state,
					currentReasonId: null
				};


		case ReasonActitonTypes.InicializeReason:

			console.log('--> Entando en acción InicializeReason.');

			state = initialState;

			return state;


		case ReasonActitonTypes.LoadReasonsSuccess:

			console.log('--> Entando en acción LoadReasonsSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					reasonList: action.payload,
					error: ''
				};

		case ReasonActitonTypes.LoadReasonsFail:

			console.log('--> Entando en acción LoadReasonsFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					reasonList: [],
					error: action.payload
				};

    case ReasonActitonTypes.LoadReasonTypesSuccess:

			console.log('--> Entando en acción LoadReasonTypesSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					reasonTypeList: action.payload,
					error: ''
				};

		case ReasonActitonTypes.LoadReasonTypesFail:

			console.log('--> Entando en acción LoadReasonTypesFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					reasonTypeList: [],
					error: action.payload
				};

		// case ReasonActitonTypes.UpdateReason:

		// 	console.log('--> Entando en acción UpdateReason.');

		// 	// state = initialState;

		// 	return state;

		case ReasonActitonTypes.UpdateReasonSuccess:

			console.log('--> Entando en acción UpdateReasonSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha modificado y el resto se deja como estaba.

			let auxReasonList = [];

			if (action.payload !== undefined) {
				console.log(' -> El proyecto a modificar es:');
				console.log(action.payload);

				if (action.payload != null) {
					auxReasonList = state.reasonList.map(
					item => action.payload.id === item.id ? action.payload : item);

					return {
						...state,
						reasonList: auxReasonList,
						currentReasonId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> La obra a modificar está vacía.');

				return {
					...state,
					error: 'No se ha podido modificar la obra.'
				};
			}

		case ReasonActitonTypes.UpdateReasonFail:

			console.log('--> Entrando en acción UpdateReasonFail.');

			return {
					...state,
					error: action.payload
				};

		case ReasonActitonTypes.CreateReasonSuccess:

			console.log('--> Entrando en acción CreateReasonSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha creado.
			// this.currentReasons = null;

			if (action.payload !== undefined) {
				console.log(' -> El proyecto creado es:');
				console.log(action.payload);

				if (action.payload != null) {

					state.reasonList.push(action.payload);

					return {
						...state,
						reasonList: state.reasonList,
						currentReasonId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El proyecto a crear está vacío.');

				return {
					...state,
					currentReasonId: null,
					error: 'No se ha podido crear la obra.'
				};
			}

		case ReasonActitonTypes.CreateReasonFail:

			console.log('--> Entrando en acción CreateReasonFail.');

			return {
					...state,
					currentReasonId: null,
					error: action.payload
				};

		case ReasonActitonTypes.DeleteReasonSuccess:

			console.log('--> Entrando en acción DeleteReasonSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha creado.
			// this.currentReasons = null;

			if (action.payload !== undefined) {
				console.log(' -> El proyecto borrado con éxito es:');
				console.log(action.payload);

				if (action.payload != null) {

					const filterList = state.reasonList.filter((item) => item.id.toString() !== action.payload.toString());

					console.log(' -> Lista filtrada de obras:');
					console.log(filterList);

					return {
						...state,
						reasonList: filterList,
						currentReasonId: null,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El proyecto a crear está vacío.');

				return {
					...state,
					currentReasonId: null,
					error: 'No se ha podido crear la obra.'
				};
			}

		case ReasonActitonTypes.DeleteReasonFail:

			console.log('--> Entrando en acción DeleteReasonSuccess.');

			return {
					...state,
					currentReasonId: null,
					error: action.payload
				};

		case ReasonActitonTypes.LoadUsersSuccess:

			console.log('--> Entando en acción LoadUsersSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					userList: action.payload,
					error: ''
				};

		case ReasonActitonTypes.LoadUsersFail:

			console.log('--> Entando en acción LoadUsersFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					userList: [],
					error: action.payload
				};

		default:
			return state;
	}
}
